import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Switch, Route } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import MeetingModalityList from "./MeetingModalityList";
import MeetingModalityDetail from "./MeetingModalityDetail";
export const getMeetingModalityBasePath = () => `${getAdminBasePath()}/meetingModality`;
export const getMeetingModalityBaseRoute = () => `${getAdminBaseRoute()}/meetingModality`;
export const getMeetingModalityIndexRoute = () => `${getMeetingModalityBaseRoute()}`;
export const getMeetingModalityIndexPath = () => `${getMeetingModalityBasePath()}`;
export const getMeetingModalityDetailPath = (id) => `${getMeetingModalityBasePath()}/${id}`;
export const getMeetingModalityDetailRoute = () => `${getMeetingModalityBaseRoute()}/:id`;
const AdminMeetingModalityRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route, { component: MeetingModalityDetail, path: getMeetingModalityDetailRoute() }), _jsx(Route, { component: MeetingModalityList, path: getMeetingModalityIndexRoute() })] }));
};
export default AdminMeetingModalityRoutes;
